import { CUBE_AGGREGATE_INTERACTION } from '@/api/hcp/interaction/types';
import { Channel } from '@/models/channelFocus';
import { FilterConfig } from '@/types/filter';

const channelFilter: FilterConfig = {
  label: 'main.channelFocus.hcpCoverage.filters.channel.label',
  placeholder: 'main.channelFocus.hcpCoverage.filters.channel.placeholder',
  type: 'multiselect',
  clearable: true,
  searchable: true,
  hidden: true,
  options: [
    { label: Channel.EMAIL, value: Channel.EMAIL },
    { label: Channel.VISITS_1_TO_1, value: Channel.VISITS_1_TO_1 },
    { label: Channel.EVENT, value: Channel.EVENT },
    { label: Channel.WEBSITE, value: Channel.WEBSITE },
  ],
  defaultValue: [],
  applyFilter: value => {
    switch (value) {
      case Channel.EMAIL:
        return {
          member: `${CUBE_AGGREGATE_INTERACTION}.channel`,
          operator: 'equals',
          values: ['Email'],
        };
      case Channel.WEBSITE:
        return {
          member: `${CUBE_AGGREGATE_INTERACTION}.is_website_visit`,
          operator: 'equals',
          values: ['true'],
        };
      case Channel.VISITS_1_TO_1:
        return undefined;
      case Channel.EVENT:
        return undefined;
    }
  },
};

export default channelFilter;
